export default "__VITE_ASSET__j8t1W91P__"